import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* CREATE */
export const createSpecType = (data)=>{
  return api.post(ENDPOINTS.SPEC_TYPES.CREATE,data);
};

/* LIST */
export const listSpecTypeByParams = (data)=>{
  return api.post(ENDPOINTS.SPEC_TYPES.SEARCH,data);
};

/* GET BY ID */
export const getSpecTypeById = (id)=>{
  return api.get(ENDPOINTS.SPEC_TYPES.BY_ID(id));
};

/* UPDATE */
export const updateSpecType = (id,data)=>{
  return api.put(ENDPOINTS.SPEC_TYPES.UPDATE(id),data);
};

/* DELETE */
export const deleteSpecType = (id)=>{
  return api.delete(ENDPOINTS.SPEC_TYPES.DELETE(id));
};

/* FAMILY DROPDOWN */
export const familyDropdown = ()=>{
  return api.get(ENDPOINTS.SPEC_TYPES.FAMILY_DROPDOWN);
};